import { css, StyleSheet } from 'aphrodite'
import { PropTypes } from 'prop-types'
import logo from '../../assets/logo.png'
import { Link } from 'react-router-dom'
import textWhiteLogo from '../../assets/logo_text_white.png'
import WhiteLogo from '../../assets/logo_white.svg'
import { MEDIA_MIN_SM } from '../../lib/breakpoints'

const UILogo = ({ dynamicStyle, logoWithTextWhite, logoWhite, logoStyle }) => {
  return (
    <div className={dynamicStyle ? css(dynamicStyle) : null}>
      <Link to="/">
        <img
          src={logoWithTextWhite ? textWhiteLogo : logoWhite ? WhiteLogo : logo}
          className={logoStyle ? css(logoStyle) : css(styles.logo)}
          alt="ubiqeye logo"
          width={78}
          height="100%"
        />
      </Link>
    </div>
  )
}

const styles = StyleSheet.create({
  logo: {
    width: 78,
    [MEDIA_MIN_SM]: {
      width: 120,
    },
  },
  bigLogo: {
    width: 78,
    [MEDIA_MIN_SM]: {
      width: 200,
    },
  },
  notFoundLogo: {
    width: 70,
    [MEDIA_MIN_SM]: {
      width: 70,
    },
  },
})

UILogo.propTypes = {
  dynamicStyle: PropTypes.object,
  logoWithTextWhite: PropTypes.bool,
  logoWhite: PropTypes.bool,
  logoStyle: PropTypes.object,
}
export default UILogo
